export const delay = (ms: number) => {
  let timer: number;
  return Object.assign(
    new Promise((res) => {
      timer = setTimeout(res, ms);
    }),
    {
      reset: () => {
        clearTimeout(timer);
      },
    }
  );
};
